import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { WhySection } from './components/WhySection';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesPopup } from './components/SalesPopup';
interface AppProps {
  showSalesPopup?: boolean;
}
export function App({
  showSalesPopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '757545003709827');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="sudlkfnv5z8s">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=757545003709827&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="stuczpk3sn7f" />
      </noscript>
      <div className="flex min-h-screen w-full flex-col items-center overflow-x-hidden bg-ice" data-id="element-2" data-mp="3ubztg9s4bhe4">
        <main className="w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="d3cw3t2oyyh3">
          <Hero data-id="element-4" data-mp="851kpdwr0fwr" />
          <WhySection data-id="element-5" data-mp="86mf93j2byum" />
          <SystemOverview data-id="element-6" data-mp="8648ve2os48z" />
          <Modules data-id="element-7" data-mp="83qihiiybg7r" />
          <LookInside data-id="element-8" data-mp="3gl4qfe4avuig" />
          <Bonuses data-id="element-9" data-mp="3gmfvride9abo" />
          <Differentiators data-id="element-10" data-mp="3glwbvw46obv0" />
          <Offer data-id="element-11" data-mp="3gj1s86szuv2n" />
          <Guarantee data-id="element-12" data-mp="3bmjq7ep1tau0" />
          <Testimonials data-id="element-13" data-mp="3bn2zy84joswy" />
          <FAQ data-id="element-14" data-mp="3bnuwbl5yuuoa" />
          <FinalCTA data-id="element-15" data-mp="3bk70gfd1tw6e" />
          <Footer data-id="element-16" data-mp="3qb7k7gj8xchu" />
        </main>
        {showSalesPopup ? <SalesPopup data-id="element-17" data-mp="3qbzcoihjqu3w" /> : null}
      </div>
    </>;
}